module.exports = __webpack_public_path__ + "media/images/ui__textArrowUpLight-570c2fd7fb9c0848837eb7c5b639eacc.png";